import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/articles';

export default function Footer() {
  const footerColumns = [
    {
      title: '热门分类',
      links: categories.slice(0, 4).map((c) => ({
        label: c.name,
        to: `/category/${c.slug}`,
      })),
    },
    {
      title: '快速链接',
      links: [
        { label: '首页', to: '/' },
        { label: '最新爆料', to: '/category/heiliaodagua' },
        { label: 'APP下载', to: '#download' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '联系方式',
      links: [
        { label: '商务合作：hello@baoliaoshe.cn', to: 'mailto:hello@baoliaoshe.cn' },
        { label: '内容投稿：hello@baoliaoshe.cn', to: 'mailto:hello@baoliaoshe.cn' },
        { label: '投诉建议：hello@baoliaoshe.cn', to: 'mailto:hello@baoliaoshe.cn' },
      ],
    },
    {
      title: '关注我们',
      links: [
        { label: '新浪微博', to: 'http://baoliaoshe.cn/', external: true },
        { label: '微信公众号', to: '#', external: false },
        { label: '抖音号：51chigua', to: '#', external: false },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white mb-4 tracking-wide">
                {col.title}
              </h4>
              <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.to}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 md:mt-16 pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <Link to="/" className="font-heading text-2xl font-black text-white tracking-tight">
                51吃瓜网
              </Link>
              <div className="w-12 h-0.5 bg-primary-500/60 mt-2 mb-3"></div>
              <p className="text-xs text-foreground-400 max-w-xs leading-relaxed">
                {siteInfo.tagline}
              </p>
            </div>

            <div className="flex flex-col items-start sm:items-end gap-3">
              <div className="flex items-center gap-4">
                <a href="http://baoliaoshe.cn/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700/50 text-foreground-300 hover:text-primary-400 hover:bg-primary-500/20 transition-all duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700/50 text-foreground-300 hover:text-primary-400 hover:bg-primary-500/20 transition-all duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700/50 text-foreground-300 hover:text-primary-400 hover:bg-primary-500/20 transition-all duration-200" aria-label="抖音">
                  <i className="ri-tiktok-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700/50 text-foreground-300 hover:text-primary-400 hover:bg-primary-500/20 transition-all duration-200" aria-label="B站">
                  <i className="ri-bilibili-line text-base"></i>
                </a>
              </div>
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 51吃瓜网 版权所有
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}